import React from "react";
import Utility from "../../utilities/Utility";

export default class PreviewLinkView extends React.Component {
    /**
     * Link view for diagram preview; no mouse events
     * @module PreviewLinkView
     * @param {Object} props React props
     */
    constructor(props) {
        super(props);
        this.state = {
            selected: false
        }
    }

    /**
     * Generate link SVG
     * @param {Object} extraProps
     * @param {number} id Link index
     * @param {Object} attachment Link attachment anchor point
     * @returns {XML}
     */
    generateLink(extraProps, id, attachment) {
        const hasError = this.props.link.hasError();
        const Bottom = (
            <path
                className={
                    this.props.link.props.colorClass
                    + (this.state.selected || this.props.link.isSelected() ? " selected" : "")
                    + (hasError ? " error" : "")
                }
                strokeWidth={this.props.width}
                {...extraProps}
            />
        );

        const Top = (
            <path
                className={
                    this.props.link.props.colorClass
                    + (hasError ? " error top" : "")
                }
                strokeLinecap="round"
                data-linkid={this.props.link.getID()}
                strokeOpacity={this.state.selected || this.props.link.isSelected() ? 0.3 : 0}
                strokeWidth={14}
                {...extraProps}
            />
        );

        return (
            <g key={"link-" + id}>
                {Bottom}
                {Top}
            </g>
        );
    }

    /**
     * React render
     * @returns {XML}
     */
    render() {
        //ensure id is present for all points on the path
        var paths = [];
        const points = this.props.link.points;
        const numPoints = points.length;
        // directional triangle
        const pPerc = 0.85;
        // approx. derivative at directional triangle
        const t1Perc = pPerc - 0.005;
        const t2Perc = pPerc + 0.005;
        // curve midpoint
        const mPerc = 0.5;

        //draw the smoothed curve
        if (numPoints >= 2){
            const segments = Utility.getCurve(this.props.link);
            const numSegs = segments.length;
            const maxIdx = numSegs - 1;
            const midIdx = Math.round(maxIdx / 2);

            for (var i = 0; i < segments.length; i++){
                const seg = segments[i];
                var attachment = {};

                if (i === midIdx){
                    attachment.m = Utility.getBezierCoord(seg[0], seg[1], seg[2], seg[3], mPerc);
                }
                if (i === maxIdx){
                    attachment.p = Utility.getBezierCoord(seg[0], seg[1], seg[2], seg[3], pPerc);
                    attachment.t1 = Utility.getBezierCoord(seg[0], seg[1], seg[2], seg[3], t1Perc);
                    attachment.t2 = Utility.getBezierCoord(seg[0], seg[1], seg[2], seg[3], t2Perc);
                }
                const nextPoint = i + 1;
                paths.push(
                    this.generateLink(
                        {
                            "data-linkid": this.props.link.id,
                            "data-point": i,
                            d: " M" +
                            seg[0].x + " " + seg[0].y +
                            " C " +
                            seg[1].x + " " + seg[1].y + " " +
                            seg[2].x + " " + seg[2].y + " " +
                            seg[3].x + " " + seg[3].y
                        },
                        i,
                        attachment
                    )
                );
            }
        }

        return <g>{paths}</g>;
    }
}
